<span>
  Votre compte n'a pas encore été migré sur Proxeema. <br />
  En attendant, continuez sur Ariane.</span
>

<div class="actions-container">
  <oui-button
    size="large"
    iconSuffix="open_in_new"
    (click)="redirectToAriane()"
    >Continuer sur Ariane
  </oui-button>
  <oui-button
    size="large"
    type="text"
    (click)="logout()"
    >Se connecter avec un autre compte
  </oui-button>
</div>
